import React, { useEffect, useMemo, useState } from "react";
import { Modal, Select, Spin, message } from "antd";
import { getRequest, updateRequest } from "../utils/APICall";
import moment from "moment";
import { useSelector } from "react-redux";

const STATUS_TABS = [
    { label: "All", value: "ALL" },
    { label: "In Process", value: 1 },
    { label: "Assigned", value: 0 },
    { label: "Complete", value: 3 },
    { label: "On Hold", value: 2 },
    { label: "Rejected", value: 4 },
    { label: "Canceled", value: 5 },
];

const STATUS_OPTIONS = [
    { value: 1, label: "In Process" },
    { value: 3, label: "Complete" },
    { value: 2, label: "On Hold" },
    { value: 0, label: "Assigned" },
    { value: 4, label: "Rejected" },
    { value: 5, label: "Canceled" },
];

export default function MyTasks() {
    const [loading, setLoading] = useState(true);
    const [confirmationModal, setConfirmationModal] = useState(false);
    const [tasks, setTasks] = useState([]);
    const [tasksData, setTasksData] = useState([]);
    const [statusFilter, setStatusFilter] = useState("ALL");
    const { users } = useSelector((state) => state.user || {});
    const [devReviewModal, setDevReviewModal] = useState(false);
    const [devReviewText, setDevReviewText] = useState("");
    const [selectedTaskId, setSelectedTaskId] = useState(null);
    const [savingReview, setSavingReview] = useState(false);

    const fetchTasks = async () => {
        try {
            setLoading(true);
            const res = await getRequest(`getEmpTask?empId=${users?.EMPID}`);
            console.log(res.data)
            if (res?.success) setTasks(res.data);
            else setTasks([]);
        } catch (e) {
            setTasks([]);
        } finally {
            setLoading(false);
        }
    };
    const saveDevReview = async () => {

        if (!devReviewText.trim()) {
            message.warning("Please enter remark");
            return;
        }
        setSavingReview(true);
        try {
            const payload = {
                taskID: selectedTaskId,
                devReview: devReviewText
            };
            const res = await updateRequest("AddDevReview", payload);
            if (res.success) {

                message.success("Remark added successfully");
                setTasks(prev =>
                    prev.map(task =>
                        task.ID === selectedTaskId
                            ? { ...task, DEVELOPER_REVIEW: devReviewText }
                            : task
                    )
                );
                setDevReviewModal(false);
                setDevReviewText("");
            }
            else {
                message.error(res.message);
            }
        }
        catch {
            message.error("Failed to save remark");
        }
        finally {
            setSavingReview(false);
        }

    };


    useEffect(() => {
        fetchTasks();
    }, []);
    const filteredTasks = useMemo(() => {
        if (statusFilter === "ALL") return tasks;
        return tasks.filter(t => t.STATUS_ID === statusFilter);
    }, [tasks, statusFilter]);

    const updateTaskStatus = async (taskId, newStatus) => {
        const oldTasks = [...tasks];
        setTasks(prev =>
            prev.map(t => (t.ID === taskId ? { ...t, STATUS_ID: newStatus } : t))
        );
        const payload = {
            taskID: taskId,
            completedDate: newStatus == 3 ? moment().format("DD MMM YYYY h:mm:ss a") : null,
            statusID: newStatus,
        }
        // console.log("payload", payload)
        try {
            let res = await updateRequest("updateEmpTask", payload);
            // console.log(res)
            if (res.success) {
                message.success("Task status updated");
                // setTasks([])
            } else {
                message.error(res.message)
            }
        } catch (err) {
            setTasks(oldTasks);
            message.error("Failed to update status");
        }
        finally {
            setConfirmationModal(false);
            setTasksData([])
        }
    };
    const showSubmitModal = (taskId, statusId) => {
        setConfirmationModal(true);
        setTasksData({ taskId, statusId });
        // console.log(tasksData)
    };
    const handleSubmitConfirm = async () => {
        await updateTaskStatus(tasksData.taskId, tasksData.statusId);
    };
    const formatedDate = (date) => {
        if (!date) return null;

        return moment(date, [
            "DD-MMM-YYYY hh:mm A",
            "DD-MMM-YYYYhh:mmA",
            "YYYY-MM-DD HH:mm:ss",
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
        ]).format("DD-MMM-YYYY | hh:mm A");
    };


    return (
        <div className="p-6 max-w-7xl mx-auto">
            {/* Status Filter */}
            <div className="flex gap-2 mb-6 flex-wrap">
                {STATUS_TABS.map(tab => (
                    <button
                        key={tab.value}
                        onClick={() => setStatusFilter(tab.value)}
                        className={`px-4 py-2 rounded-full text-sm font-medium transition ${statusFilter === tab.value
                            ? "bg-blue-600 text-white"
                            : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                            }`}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* Task List */}
            {loading ? (
                <div className="flex justify-center py-20">
                    <Spin size="large" />
                </div>
            ) : filteredTasks.length === 0 ? (
                <div className="text-center py-20 text-gray-400">
                    No tasks found
                </div>
            ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6 items-stretch">
                    {filteredTasks.map((task) => (
                        <div
                            key={task.ID}
                            className="flex flex-col w-full bg-white border border-gray-100 
             rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300
             overflow-hidden min-h-[620px]"
                        >
                            {/* Header Section: Title aur Status dynamic hain */}
                            <div className="bg-gradient-to-r from-blue-500 to-indigo-500 p-5">
                                <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-3">
                                    <div>
                                        <h2 className="text-white text-2xl font-bold tracking-tight">
                                            {task.TITLE || "No Title"}
                                        </h2>
                                        <p className="text-blue-100 text-sm mt-1 flex items-center">
                                            <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                                            </svg>
                                            {task.WORK_TYPE || "General Task"}
                                        </p>
                                    </div>
                                    <div className="flex gap-3 flex-col">

                                        <button
                                            onClick={() => {
                                                setSelectedTaskId(task.ID);
                                                setDevReviewText(task.DEVELOPER_REVIEW || "");
                                                setDevReviewModal(true);
                                            }}
                                            className="text-xs bg-indigo-600 hover:bg-indigo-700 text-white px-3 py-1 rounded-lg"
                                        >
                                            {task.DEVELOPER_REVIEW ? "Edit Remark" : "Add Remark"}
                                        </button>

                                        <Select
                                            size="small"
                                            value={task.STATUS_ID}
                                            options={STATUS_OPTIONS}
                                            // onChange={(value) => updateTaskStatus(task.ID, value)}
                                            onChange={(value) => showSubmitModal(task.ID, value)}
                                            className="custom-status-select bg-white min-w-[110px]"
                                            variant="borderless"
                                            style={{
                                                // backgroundColor: 'rgba(255, 255, 255, 0.15)',
                                                borderRadius: '20px',
                                                backdropFilter: 'blur(8px)',
                                                border: '1px solid rgba(255, 255, 255, 0.2)',
                                                color: '#9ca3af'
                                            }}
                                        />
                                    </div>

                                </div>
                            </div>

                            <div className="p-6 space-y-6">
                                {/* Description Section */}
                                <div>
                                    <h3 className="text-gray-400 text-[10px] uppercase tracking-widest font-bold mb-2 text-left flex items-center gap-1.5">
                                        <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                        </svg>
                                        Task Overview
                                    </h3>
                                    <p className="text-gray-700 text-wrap leading-relaxed font-medium text-left text-sm">
                                        {task.DESCRIPTION}
                                    </p>
                                </div>

                                {/* 2. Developer Review (The Solution/Work) */}
                                {task?.DEVELOPER_REVIEW && (
                                    <div className="bg-indigo-50/50 border border-indigo-100 p-4 rounded-xl text-left relative overflow-hidden group">
                                        <h3 className="text-indigo-500 text-[10px] uppercase tracking-widest font-bold mb-2 flex items-center gap-1.5">
                                            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
                                            </svg>
                                            Developer Implementation Notes
                                        </h3>
                                        <p className="text-slate-600 text-sm leading-relaxed font-medium">
                                            {task.DEVELOPER_REVIEW}
                                        </p>
                                    </div>
                                )}

                                {/* 3. Client Review Box (The Feedback) */}
                                {task?.CLIENT_REVIEW && (
                                    <div className="bg-amber-50 border-l-4 border-amber-400 p-4 rounded-r-xl text-left shadow-sm">
                                        <div className="flex items-center gap-2 mb-1.5">
                                            <svg className="w-3.5 h-3.5 text-amber-500 fill-amber-500" viewBox="0 0 20 20">
                                                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                                            </svg>
                                            <h3 className="text-amber-700 text-[10px] uppercase tracking-widest font-extrabold">
                                                Client Feedback
                                            </h3>
                                        </div>
                                        <p className="text-sm text-gray-800 italic font-semibold leading-snug">
                                            "{task?.CLIENT_REVIEW}"
                                        </p>
                                        <p className="text-[9px] text-amber-600 mt-2 uppercase font-bold tracking-tighter">— Performance Review</p>
                                    </div>
                                )}

                                <hr className="border-gray-100" />

                                {/* Grid Data: Personnel and Priority */}
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div className="space-y-4">
                                        <div className="flex items-center space-x-3">
                                            <div className="p-2 bg-indigo-50 rounded-lg text-indigo-600">
                                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
                                            </div>
                                            <div className="text-left">
                                                <p className="text-xs text-gray-500 font-semibold uppercase">Assigned To</p>
                                                <p className="text-sm text-gray-800 font-bold">{task.EMPLOYEE_NAMES || "Unassigned"}</p>
                                            </div>
                                        </div>

                                        <div className="flex items-center space-x-3">
                                            <div className="p-2 bg-purple-50 rounded-lg text-purple-600">
                                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" /></svg>
                                            </div>
                                            <div className="text-left">
                                                <p className="text-xs text-gray-500 font-semibold uppercase">Requested By</p>
                                                <p className="text-sm text-gray-800 font-bold">{task.COMPLAINBY}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="space-y-4">
                                        <div className="flex items-center space-x-3">
                                            <div className={`p-2 rounded-lg ${task.PRIORITY_TITLE === 'High' ? 'bg-red-50 text-red-600' : 'bg-blue-50 text-blue-600'}`}>
                                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                                            </div>
                                            <div className="text-left">
                                                <p className="text-xs text-gray-500 font-semibold uppercase">Priority</p>
                                                <span className={`text-sm font-black ${task.PRIORITY_TITLE === 'High' ? 'text-red-600' : 'text-blue-600'}`}>
                                                    {task.PRIORITY_TITLE} Priority
                                                </span>
                                            </div>
                                        </div>

                                        <div className="flex items-center space-x-3">
                                            <div className="p-2 bg-orange-50 rounded-lg text-orange-600">
                                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" /></svg>
                                            </div>
                                            <div className="text-left">
                                                <p className="text-xs text-gray-500 font-semibold uppercase">Turnaround Time</p>
                                                <p className="text-sm text-gray-800 font-bold tracking-tight">{task.COMPLETE_DURATION_DAYS || "In Progress"}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Timeline Footer: Mobile responsive grid */}
                                <div className="mt-6 pt-4 border-t border-gray-100 grid grid-cols-2 sm:grid-cols-3 gap-4 text-[11px]">
                                    <div className="text-center sm:text-left">
                                        <p className="text-gray-400 uppercase font-bold text-[10px]">Complained</p>
                                        <p className="text-gray-700 font-semibold mt-1">{formatedDate(task?.COMPLAINDATE) || "N/A"}</p>
                                    </div>
                                    <div className="text-center sm:text-left">
                                        <p className="text-gray-400 uppercase font-bold text-[10px]">Due Date</p>
                                        <p className="text-gray-700 font-semibold mt-1">{formatedDate(task?.DUE_DATE) || "N/A"}</p>
                                    </div>
                                    <div className="text-center sm:text-right col-span-2 sm:col-span-1 border-t sm:border-t-0 sm:border-l border-gray-100 pt-3 sm:pt-0">
                                        <p className="text-green-600 uppercase font-bold text-[10px]">Completed At</p>
                                        <p className="text-gray-700 font-semibold mt-1 text-sm">{formatedDate(task?.COMPLETEDATE) || "N/A"}</p>
                                    </div>

                                </div>
                            </div>
                        </div>
                    ))}
                    <Modal
                        title="Confirm Submission"
                        open={confirmationModal}
                        onOk={handleSubmitConfirm}
                        onCancel={() => setConfirmationModal(false)}
                        okText="Yes"
                        cancelText="Cancel"
                    >
                        <p className="">Are you sure you want to Update this  Task Status ?</p>
                    </Modal>
                    <Modal
                        title="Developer Remark"
                        open={devReviewModal}
                        onOk={saveDevReview}
                        onCancel={() => setDevReviewModal(false)}
                        confirmLoading={savingReview}
                    >

                        <textarea
                            rows={4}
                            value={devReviewText}
                            onChange={(e) => setDevReviewText(e.target.value)}
                            placeholder="Write what issue was and what you did..."
                            className="w-full border rounded-lg p-2 outline-none"
                        />

                    </Modal>

                </div>
            )}
        </div>
    );
}